import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class AuthErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    console.error('Auth Error Boundary caught error:', error);
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Auth error details:', error, errorInfo);
    
    // If it's an auth-related error, try to recover
    if (error.message?.includes('id') || 
        error.message?.includes('user') ||
        error.message?.includes('undefined')) {
      
      console.log('🔄 Attempting auth recovery...');
      
      // Clear potentially corrupted auth state
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      
      // Reload the page to restart auth flow
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#f5f5f5',
          margin: '20px',
          borderRadius: '8px'
        }}>
          <h2>Authentication Error</h2>
          <p>There was an issue with authentication. Reloading...</p>
          <p style={{ fontSize: '12px', color: '#666' }}>
            {this.state.error?.message}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AuthErrorBoundary;